function sortColumn(a, b, key) {
  if (!a[key] && !b[key]) {
    return -1;
  } else if (!a[key] && b[key]) {
    return -1;
  } else if (a[key] && !b[key]) {
    return 1;
  }
  return a[key] - b[key] >= 0 ? 1 : -1;
}
export const indicatorList = [
  { label: "累计收入", value: "1", listKey: "totalIncomeList" },
  { label: "LTV", value: "2", listKey: "ltvList" },
  { label: "ROI", value: "3", listKey: "roiList" },
  { label: "留存率", value: "4", listKey: "retentionRateList" },
  { label: "留存人均ARPU", value: "5", listKey: "retentionArpuList" },
];
export const summary_date_table_column = [
  {
    id: 0,
    key: "installDay",
    name: "日期",
    sort: true,
    point: 0,
    width: 150,
    fixed: true,
    show: true,
  },
  {
    id: 1,
    key: "installs",
    name: "总新增",
    sort: true,
    point: 0,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "installs"),
    show: true,
  },
  {
    id: 2,
    key: "popTotal",
    name: "推广总计",
    unit: "$",
    sort: true,
    point: 2,
    width: 190,
    sortMethod: (a, b) => sortColumn(a, b, "popTotal"),
    show: true,
  },
  {
    id: 3,
    key: "cresCost",
    name: "新增成本",
    unit: "$",
    sort: true,
    point: 2,
    width: 190,
    sortMethod: (a, b) => sortColumn(a, b, "cresCost"),
    show: true,
  },
];
export const summary_country_table_column = [
  {
    id: 0,
    key: "geo",
    name: "国家或地区",
    sort: false,
    point: 0,
    width: 150,
    fixed: true,
  },
  {
    id: 1,
    key: "installs",
    name: "总新增",
    sort: true,
    point: 0,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "installs"),
  },
  {
    id: 2,
    key: "popTotal",
    name: "推广总计",
    unit: "$",
    sort: true,
    point: 2,
    width: 190,
    sortMethod: (a, b) => sortColumn(a, b, "popTotal"),
    show: true,
  },
  {
    id: 3,
    key: "cresCost",
    name: "新增成本",
    unit: "$",
    sort: true,
    point: 2,
    width: 190,
    sortMethod: (a, b) => sortColumn(a, b, "cresCost"),
    show: true,
  },
];
export const summary_medio_table_column = [
  {
    id: 0,
    key: "mediaSource",
    name: "资源",
    sort: true,
    point: 0,
    width: 150,
    fixed: true,
  },
  {
    id: 1,
    key: "installs",
    name: "总新增",
    sort: true,
    point: 0,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "installs"),
  },
  {
    id: 2,
    key: "popTotal",
    name: "推广总计",
    unit: "$",
    sort: true,
    point: 2,
    width: 190,
    sortMethod: (a, b) => sortColumn(a, b, "popTotal"),
    show: true,
  },
  {
    id: 3,
    key: "cresCost",
    name: "新增成本",
    unit: "$",
    sort: true,
    point: 2,
    width: 190,
    sortMethod: (a, b) => sortColumn(a, b, "cresCost"),
    show: true,
  },
];
export const summary_camp_table_column = [
  {
    id: 0,
    key: "mediaSource",
    name: "资源",
    sort: false,
    point: 0,
    width: 150,
    fixed: true,
  },
  {
    id: 1,
    key: "campaign",
    name: "campaign",
    sort: false,
    point: 0,
    width: 150,
    fixed: true,
  },
  {
    id: 2,
    key: "installs",
    name: "总新增",
    sort: true,
    point: 0,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "installs"),
  },
  {
    id: 3,
    key: "popTotal",
    name: "推广总计",
    unit: "$",
    sort: true,
    point: 2,
    width: 190,
    sortMethod: (a, b) => sortColumn(a, b, "popTotal"),
    show: true,
  },
  {
    id: 4,
    key: "cresCost",
    name: "新增成本",
    unit: "$",
    sort: true,
    point: 2,
    width: 190,
    sortMethod: (a, b) => sortColumn(a, b, "cresCost"),
    show: true,
  },
];
